import React from "react";
import GroupBookingMainPage from "./groups/GroupBookingMainPage";
import GroupMainPage from "./assign-group/GroupMainPage";
import ModelGroupMainPage from "./assign-model-group/ModelGroupMainPage";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { OwcExpandable, OwcExpandableGroup } from "@one/react";
import {
  BookingAccessControlProvider,
} from "./BookingAccessControlContext";
import styles from "./BookingAccessControl.module.scss";


const BookingAccessControl = ({ client, loadBookingInstruments, getBookingItems }) => {
  const [expanded, setExpanded] = React.useState("createGroupAccordion");

  const { trackPageView } = useMatomo();
  React.useEffect(() => {
    trackPageView({
      documentTitle: "Admin Panel/Booking access control",
      href: `${window.location?.origin}/AdminPanel/BookingAccessControl`,
    });
    // Removed getBookingItems() call - instruments are now loaded on-demand via Redux
    // eslint-disable-next-line
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <BookingAccessControlProvider>
        <OwcExpandableGroup>
          <OwcExpandable
            variant="standard"
            round
            expanded={expanded === "createGroupAccordion"}
            onStatusChanged={handleChange("createGroupAccordion")}
            className={styles.OwcExpandable}
          >
            <span slot="title">Create booking group </span>
            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <GroupBookingMainPage />
            </span>
          </OwcExpandable>

          <OwcExpandable
            variant="standard"
            round
            expanded={expanded === "assignGroupAccordion"}
            onChange={handleChange("assignGroupAccordion")}
            className={styles.OwcExpandable}
          >
            <span slot="title">Assign group to equipment</span>

            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <GroupMainPage />
            </span>
          </OwcExpandable>
          <OwcExpandable
            variant="standard"
            round
            expanded={expanded === "assignModelGroupAccordion"}
            onChange={handleChange("assignModelGroupAccordion")}
            className={styles.OwcExpandable}
          >
            <span slot="title">Assign group to equipment model and location</span>

            <span
              slot="content"
              style={{
                minHeight: "fit-content",
                overflowY: "scroll",
              }}
            >
              <ModelGroupMainPage />
            </span>
          </OwcExpandable>
        </OwcExpandableGroup>
      </BookingAccessControlProvider>
    </>
  );
};

export default BookingAccessControl;
